import axios from "axios";
import { doc, getDoc, getFirestore, onSnapshot, setDoc } from "firebase/firestore";
import {getFunctions,httpsCallable} from "firebase/functions";
import { useEffect, useState } from "react";
import { CloseButton, Table } from "react-bootstrap";
import { AiFillCodeSandboxCircle } from "react-icons/ai";
import { CgClose, CgCross, CgTapDouble } from "react-icons/cg";
import { FaPen } from "react-icons/fa";
import swal from "sweetalert";
import "../noscroll.css"
import UserOrderHistory from "./userOrderHistory";
import UserTransactionHistory from "./userTransactionHistory";

export default function UserDetails(props){
    
    const functions = getFunctions();
    const db=getFirestore();
    const [currentUserDetails,setCurrentUserDetails]= useState(undefined);
    const [wallet,setWallet]=useState(0);
    var testingArray=[1,1,1,1,1,1,1,1,1,1,1];

    useEffect(async()=>{

        console.log("curent Id is"+props.id);

        const unsubscribe= onSnapshot(doc(db,"users",props.id),(doc)=>{
            var data= doc.data();
            setCurrentUserDetails(data);
            setWallet(data["wallet"]);
        })

        return function(){
            unsubscribe();
        }

    },[]);

    return (
        <div className="flex flex-row z-10 absolute backdrop-blur-sm w-full">
            <div className="w-2/4 bg-transparent relative"></div>
            
            <div className="p-10 w-2/4 bg-black/90 flex justify-start items-start relative flex-col overflow-scroll">
                

                <div className="self-end">
                    <button
                    onClick={()=>{
                       props.closeButton()
                    }}
                    >
                        <CgClose size={50}/>
                    </button>
                </div>

                <div style={{backgroundImage:`url('${currentUserDetails===undefined?"":currentUserDetails["imgSrc"]}')`}} className="mb-3 bg-black h-48 w-48 bg-cover bg-center rounded"/>

                <div className="mb-10 w-full text-white text-6xl font-bold">
                    {currentUserDetails===undefined?"":currentUserDetails["fullName"]}
                    <button
                        className="ml-5"
                         onClick={()=>{
                            console.log("name Changed");
                                                
                            swal("Kindly Enter New User Name for this User.",
                                 {
                                    content: "input",
                                }).then(async(value) => {
                                        if(value.trim()!="")
                                        {
                                            await setDoc(doc(db,"users",props.id),{"fullName":value.trim()},{merge:true});
                                        }
                                        else
                                        {
                                            swal(`You Entered an empty value`);
                                        }
                                    });
                            }}>
                            <FaPen size={30}/>
                    </button>
                </div>

                <Table bordered className="text-white table-fixed">
                    <tbody>

                    {/* <tr>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            Name
                                        </div>
                        </td>
                        <td className="w-2/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            {currentUserDetails===undefined?"":currentUserDetails["fullName"]}
                                        </div>
                        </td>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-center items-center overflow-x-scroll">
                                            <button
                                            onClick={()=>{
                                                console.log("name Changed");
                                                
                                                swal("Kindly Enter New User Name for this User.", {
                                                    content: "input",
                                                }).then(async(value) => {
                                                        if(value.trim()!=""){
                                                            // let data= (await getDoc(doc(db, "appSettings", "categories"))).data();
                                                            // data["categories"][currentCategory]["name"]=value;
                                                            // setDoc(doc(db,"appSettings","categories"),data,{merge:true});
                                                        }
                                                        else{
                                                            swal(`You Entered an empty value`);
                                                        }
                                                });
        
                                            }}>
                                                <FaPen size={24}/>
                                            </button>
                                        </div>
                        </td>        
                    </tr> */}

                    <tr>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            Email
                                        </div>
                        </td>
                        <td className="w-2/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            {currentUserDetails===undefined?"":currentUserDetails["email"]}
                                        </div>
                        </td>
                        <td className="w-1/4">
                        </td>        
                    </tr>

                    <tr>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            Phone
                                        </div>
                        </td>
                        <td className="w-2/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            {currentUserDetails===undefined?"":currentUserDetails["countryCode"]}{currentUserDetails===undefined?"":currentUserDetails["phone"].toString().substr(1).toString()  }
                                        </div>
                        </td>
                        <td className="w-1/4">
                        </td>        
                    </tr>


                    <tr>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            Country
                                        </div>
                        </td>
                        <td className="w-2/4">
                                <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                    {currentUserDetails===undefined?"":currentUserDetails["country"] }
                                </div>
                        </td>
                        <td className="w-1/4">
                        </td>        
                    </tr>

                    <tr>
                        <td className="w-1/4">
                                        <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                            Wallet
                                        </div>
                        </td>
                        <td className="w-2/4">
                                <div className="p-1 h-15 flex justify-start items-center overflow-x-scroll">
                                    <input 
                                    onChange={(e)=>{setWallet(e.target.value)}}
                                    type={"number"} className="border-none focus:border-none p-1 text-black rounded-sm" placeholder={currentUserDetails===undefined?"":currentUserDetails["wallet"].toString() }></input>
                                </div>
                        </td>
                        <td className="w-1/4">
                            <div className="p-1 h-15 flex justify-center items-center overflow-x-scroll">
                                                <button
                                                 className=" bg-red-500 p-2 rounded hover:scale-105"
                                                 onClick={async()=>{
                                                    await setDoc(doc(db,"users",props.id),{"wallet":Number.parseInt(wallet)},{merge:true})
                                                    swal("Updated","The User Wallet was updated","success");
                                                }}>
                                                    Update
                                                </button>
                            </div>
                        </td>        
                    </tr>
                        

                    </tbody>
                </Table>

                <div className="h-48 w-full flex justify-center items-center">
                    {currentUserDetails===undefined?<div/>:
                        <div className="flex flex-col w-full justify-center items-center ">

                            <button 
                            onClick={async()=>{
                                var data= (await getDoc(doc(db,"users",props.id))).data();
                                data["disabled"]=!data["disabled"];
                                await setDoc(doc(db,"users",props.id),data,{merge:true});

                                if(data["disabled"]==true){
                                    swal("Blocked","The User has been Blocked","success");
                                }
                                else{
                                    swal("Unblocked","The User has been Unblocked","success");
                                }
                            }}
                            className="p-2 rounded-md text-white w-2/4 font-bold bg-red-500 hover:scale-105 mb-2">
                                {currentUserDetails["disabled"]===true?"Unblock":"Block"}
                            </button>  

                            <button 
                            onClick={async()=>{
                                swal("Send Notifications","Kindly Enter Message to send to the user.",{content:"input"}).then((msg)=>{


                                    const addMessage = httpsCallable(functions, 'manuallySendToUser');
                                    addMessage({"user":props.id,"message":msg.toString()})
                                    
                                    axios.get(`https://us-central1-funnel-887b0.cloudfunctions.net/manuallySendToUser?user=${props.id}&message=${msg}`);

                                    console.log("sent");
                            
                                });

                            }}
                            className="p-2 rounded-md text-white w-2/4 font-bold bg-red-500 hover:scale-105">
                                Send Notification
                            </button>


                        </div> 
                    }
                </div>

                <div className="text-xl mb-4 font-bold">Order History</div>
                <UserOrderHistory id={props.id}/>


                <div className="text-xl mb-4 font-bold mt-24">Transaction History</div>
                <UserTransactionHistory id={props.id}/>
                
            

            </div>
        
        </div>
    )
}